@use '../../../../components/chart-x-axis/shared-axis-styles' as *;

@layer design-system {
  .chartAxisG {
    @include shared-axis-styles;

    :global(.tick) > line {
      stroke-width: 1;
    }
  }
}
